// smsscreen.component.jsx
import React, { useContext, useState, useEffect } from 'react';
import './smsscreen.styles.scss';
import { SimContext } from '../../api/SimContext';
import { IoMdSearch } from 'react-icons/io';
import Sidebar from '../../components/sidebar/sidebar.component';
import HeaderComponent from '../../components/header-component/header.component';
import HeadingSecondary from '../../components/typography/headings/heading-secondary/heading-secondary.component';
import { IoReloadCircleSharp } from "react-icons/io5";
import { useSelector } from 'react-redux';
import { useToken } from '../../api/TokenContext'; 
import axios from 'axios';

const SmsScreen = () => {
  const { allSims, reloadKey, setReloadKey, sendSms } = useContext(SimContext);
  const [isSpinning, setIsSpinning] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [messages, setMessages] = useState({});
  const [smsList, setSmsList] = useState([]);
  const showSidebar = useSelector((state) => state.ui.sidebarOpen);
  const isMobile = window.innerWidth <= 766;
  const [showSidebarMobile, setShowSidebarMobile] = useState(false);
  const { token } = useToken();

  const handleReload = () => {
    setIsSpinning(true);
    setTimeout(() => {
      setReloadKey(reloadKey + 1);
      setIsSpinning(false);
    }, 1000);
  };

  const handleSendMessage = async (simId) => {
    try {
      console.log(`Debug - SIM ID: ${simId}`); 
      const messageToSend = messages[simId];
      if (!messageToSend) {
        alert('Please enter a message before sending.');
        return;
      }

      await sendSms(simId, messageToSend);

      setMessages(prevMessages => ({
        ...prevMessages,
        [simId]: ''
      }));

      alert('Message sent successfully!');
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message.');
    }
  };

  const fetchSmsMessages = async () => {
    try {
      const response = await axios.get('https://portal.oneworldnumber.com/api/sms-message?page=0&size=10&sort=smsMessageReceiveDate,DESC', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setSmsList(response.data);
    } catch (error) {
      console.error('Error fetching SMS messages:', error);
    }
  };

  useEffect(() => {
    fetchSmsMessages();
  }, [reloadKey]);

  useEffect(() => {
    const filtered = allSims.filter(sim =>
      (sim.msisdn && sim.msisdn.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
      (sim.eid && sim.eid.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
      (sim.tags && sim.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())))
    );
    setFilteredSims(filtered);
  }, [allSims, searchTerm]);

  const [filteredSims, setFilteredSims] = useState([]);

  return (
    <div className='header-layout'>
      <div className="bottom-nav-container">
        <HeaderComponent showSidebarMobile={showSidebarMobile} setShowSidebarMobile={setShowSidebarMobile} />
      </div>
      <div className='portalscreen-layout'>
        {isMobile ? (
          <div className={`sidebar-container-mobile ${showSidebarMobile ? 'sidebar-visible' : ''}`}>
            <div className={`sidebar-container ${showSidebar ? 'expanded' : ''}`}>
              <Sidebar />
            </div>
          </div>
        ) : (
          <div className={`sidebar-container ${showSidebar ? 'expanded' : ''}`}>
            <Sidebar />
          </div>
        )}
        <div className='content-container'>
          <div className="messages-container">
            <div className='table-heading-container'>
              <IoReloadCircleSharp size={28} color='black' onClick={handleReload} style={{ cursor: 'pointer' }} className={`reload-div ${isSpinning ? 'spin-animation' : ''}`} />
              <div className="search-container">
                <IoMdSearch size={28} color='#646272' />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search SIM"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className='panel-small'>
              <div className='panel-heading'>
                <div className='inner-panel-heading'>
                  <div className='header-container-reseller'>
                    <HeadingSecondary text={`MSISDN - SIM EID`} mode={'dark'} />
                  </div>
                  <div className='header-container-reseller'>
                    <HeadingSecondary text={`SMS Message`} mode={'dark'} />
                  </div>
                  <div className='header-container-reseller'>
                    <HeadingSecondary text={`Action`} mode={'dark'} />
                  </div>
                </div>
              </div>
              <div className='panel-content-container'>
                <div className='sim-heading-container'>
                  <div className='sortby-container'>
                  </div>
                </div>
                <div className='scroll-container'>
                  {filteredSims.map(sim => (
                    <div key={sim.simId} className="reseller-block-table">
                      <div className="sim-info-reseller">
                        <div className="sim-text-bold">{sim.msisdn}<br />{sim.eid}</div>
                      </div>
                      <div className='dropdown-container'>
                        <input
                          type="text"
                          className="sms-message-input"
                          value={messages[sim.simId] || ''}
                          onChange={(e) => setMessages(prevMessages => ({
                            ...prevMessages,
                            [sim.simId]: e.target.value
                          }))}
                          placeholder="Enter SMS message"
                        />
                      </div>
                      <div className='send-button-container' onClick={() => handleSendMessage(sim.simId)}>
                        <button className="send-button">Send</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className='panel-small'>
              <div className='panel-heading'>
                <div className='inner-panel-heading'>
                  <div className='header-container-reseller'>
                    <HeadingSecondary text={`Fetched SMS Messages`} mode={'dark'} />
                  </div>
                </div>
              </div>
              <div className='panel-content-container'>
                <div className='sim-heading-container'>
                  <div className='sortby-container'>
                  </div>
                </div>
                <div className='scroll-container'>
                  {smsList.map(sms => (
                    <div key={sms.id} className="reseller-block-table">
                      <div className="sim-info-reseller">
                        <div className="sim-text-bold">{sms.simCardId}<br />{sms.smsMessagePayload}</div>
                      </div>
                      <div className='send-button-container'>
                        {/* <button className="send-button" onClick={() => console.log(`SMS ID: ${sms.id}`)}>View Log</button> */}
                        <button className="send-button" onClick={async () => {
                          try {
                            await axios.delete(`https://portal.oneworldnumber.com/api/sms-message/${sms.id}`, {
                              headers: {
                                'Authorization': `Bearer ${token}`
                              }
                            });
                            fetchSmsMessages();
                          } catch (error) {
                            console.error('Error deleting SMS:', error);
                          }
                        }}>Delete</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsScreen;
